import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import Config from 'constants/Config';

import GoogleMapUtils from 'utils/GoogleMapUtils';
import GeolocUtils from 'PMT/utils/GeolocUtils';

// -- entities
import Restaurant from 'PMT/entities/Restaurant';
import { Order, OrderSettings } from 'PMT/entities/order';

import RestaurantMarkerInfo from 'PMT/entities/map/RestaurantMarkerInfo';
import GoogleApiComponent from 'PMT/components/GoogleApiComponent';

// -- views
import TextInput from 'PMT/components/form/TextInput';
import GoogleMapView from './GoogleMapView';

// import withScriptjs from "react-google-maps/lib/async/withScriptjs";


/**
 * Note: geolocator import does not work well, we include it on the index.html
 *
 * - https://tomchentw.github.io/react-google-maps/basics/pop-up-window
 * - https://developers.google.com/maps/documentation/javascript/3.exp/reference
 * - https://developers.google.com/maps/documentation/javascript/tutorial#zoom-levels
 */
class DeliveryRangeMap extends Component {

  static propTypes = {
    maxRangeInMeters: PropTypes.number,

    restaurantLocation: PropTypes.object.isRequired,

    onRadiusChange: PropTypes.func.isRequired
  }

  shouldComponentUpdate(nextProps) {
    return !(
      nextProps.maxRangeInMetters === this.props.maxRangeInMetters
      && nextProps.restaurantLocation === this.props.restaurantLocation
    );
  }

  render() {
    /**
     * Notes about the zoom:
     * 1: World
     * 5: Landmass/continent
     * 10: City
     * 15: Streets
     * 20: Buildings
     *
     * https://developers.google.com/maps/documentation/javascript/tutorial#zoom-levels
     */

    if (!this.props.loaded) { // GoogleApiComponent
      return <div>Loading google maps...</div>
    }

    const restaurantLocationShortGeoPt = GeolocUtils.geoPtToShortGeoPt(this.props.restaurantLocation);
    const center = restaurantLocationShortGeoPt;

    return (
      <div
        className="map"
      >
        <GoogleMapView
          googleMapURL={GoogleMapUtils.getApiUrlWithVersion()}
          loadingElement={
            <div style={{ height: `100%` }}>
              <i className="fa fa-spinner fa-spin" />
            </div>
          }
          containerElement={
            <div style={{ height: `400px`, width: '100%' }} />
          }
          mapElement={
            <div style={{ height: `100%`, width: '100%' }} />
          }

          google={this.props.google}

          defaultCenter={restaurantLocationShortGeoPt}

          zoom={12}

          location={restaurantLocationShortGeoPt}

          userCircleRadius={this.props.maxRangeInMeters}

          onMapLoad={_.noop}

          onMapClick={_.noop}

          onRadiusChange={this.props.onRadiusChange}
        />
      </div>
    );
  }


}

export default GoogleApiComponent({
   apiKey: Config.Google.Map.API_KEY,
   version: Config.Google.Map.API_VERSION,
   url: Config.Google.Map.API_URL
})(DeliveryRangeMap);
